import React, { useEffect, useState } from "react";
import "./stylesheet/style.css";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import CinemaHallDraw from "./CinemaHallDraw";
import useExerciseManager from "./hooks/useExerciseManager";
import CinemaHallButtons from "./CinemaHallButtons";
import SelectTickets from "./SelectTickets";
import useBasketManager from "./hooks/useBasketManager";
import getId from "../../../../utils/getId";
import HeaderStepper from "./HeaderStepper";

const CinemaHall: React.FC = () => {
  const isDesktop = useDesktopSize();
  const { exerciseName, exerciseDate, exercise, exerciseDescription, moviePicture, premiere, loadingShows } =
    useExerciseManager();
  const [activeStep, setActiveStep] = useState(0);
  const {
    addAssortToBasket,
    total,
    validateBasket,
    loading,
    getTicketsListForSelectedMovie,
    clearBasket,
    postClearBasket,
    onRemoveItemFromBasket,
  } = useBasketManager();

  useEffect(() => {
    postClearBasket(() => console.log("Wyczyszczono koszyk"));
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    //eslint-disable-next-line
  }, []);

  return (
    <div className={isDesktop ? "cinema-hall-wrapper" : "cinema-hall-wrapper-mobile"}>
      <div
        className="background-hero-image"
        style={moviePicture ? { backgroundImage: `url(${moviePicture})` } : { display: "none" }}
      />
      <HeaderStepper
        title={exerciseName}
        description={exerciseDescription}
        dateInfo={exerciseDate}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        onClearBasket={clearBasket}
        premiere={premiere}
      />
      {activeStep === 0 && (
        <div className="cinema-hall-seats glass-background">
          <CinemaHallDraw exercise={exercise} />
          <CinemaHallButtons
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            totalBasket={total}
            validateBasket={validateBasket}
            onClearBasket={clearBasket}
          />
        </div>
      )}
      {activeStep === 1 && (
        <div className={"cinema-basket glass-background"}>
          <SelectTickets
            exercise={exercise}
            basket={getTicketsListForSelectedMovie(getId(exercise))}
            addAssortToBasket={addAssortToBasket}
            loading={loading || loadingShows}
            totalBasket={total}
            validateBasket={validateBasket}
            clearBasket={clearBasket}
            onRemoveItemFromBasket={onRemoveItemFromBasket}
          />
          <CinemaHallButtons
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            totalBasket={total}
            validateBasket={validateBasket}
            onClearBasket={clearBasket}
          />
        </div>
      )}
    </div>
  );
};

export default CinemaHall;
